import gte from 'semver/functions/gte';
export var checkDMPConnectJSVersion = function checkDMPConnectJSVersion(version, minimumVersion) {
  return gte(version, minimumVersion);
};